// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"845":"profile","966":"dashboard"}[chunkId] || chunkId) + "." + {"9":"4c88cc83","357":"7543a671","461":"7543a671","508":"82316fb2","845":"05223309","886":"a0b0fce3","922":"a40fbc31","966":"1137d690"}[chunkId] + ".css";
};